webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var parallaxjs = function parallaxjs(options) {
  this.options = options;
};

parallaxjs.prototype = {
  items: [],
  active: true,

  setStyle: function setStyle(item, value) {
    if (item.modifiers.centerX) value += ' translateX(-50%)';

    var el = item.el;
    var prop = 'Transform';
    el.style["webkit" + prop] = value;
    el.style["moz" + prop] = value;
    el.style["ms" + prop] = value;
  },
  add: function add(el, binding) {
    var value = binding.value;
    var arg = binding.arg;
    var style = el.currentStyle || window.getComputedStyle(el);

    var height = binding.modifiers.absY ? window.innerHeight : el.clientHeight || el.offsetHeight || el.scrollHeight;
    this.items.push({
      el: el,
      initialOffsetTop: el.offsetTop + el.offsetParent.offsetTop - parseInt(style.marginTop),
      style: style,
      value: value,
      arg: arg,
      modifiers: binding.modifiers,
      clientHeight: height,
      count: 0
    });
  },
  move: function move() {
    var _this = this;

    if (!this.active) return;
    if (window.innerWidth < this.options.minWidth || 0) {
      this.items.map(function (item) {
        _this.setStyle(item, 'translateY(' + 0 + 'px) translateZ(0px)');
      });

      return;
    }

    var scrollTop = window.scrollY || window.pageYOffset;
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;

    this.items.map(function (item) {
      var pos = scrollTop + windowHeight;
      var elH = item.clientHeight;
      // if (item.count > 50) {
      //   item.count = 0;
      //   elH = item.el.clientHeight || item.el.offsetHeight || item.el.scrollHeight
      // }


      pos = pos - elH / 2;
      pos = pos - windowHeight / 2;
      pos = pos * item.value;

      var offset = item.initialOffsetTop;
      offset = offset * -1;
      offset = offset * item.value;
      pos = pos + offset;

      pos = pos.toFixed(2);

      // item.count++
      _this.setStyle(item, 'translateY(' + pos + 'px)');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var p = new parallaxjs(options);

    window.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        p.move(p);
      });
    }, { passive: true });
    window.addEventListener('resize', function () {
      requestAnimationFrame(function () {
        p.move(p);
      });
    }, { passive: true });

    Vue.prototype.$parallaxjs = p;
    window.$parallaxjs = p;
    Vue.directive('parallax', {
      bind: function bind(el, binding) {},
      inserted: function inserted(el, binding) {
        p.add(el, binding);
        p.move(p);
      }
    });
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ParallaxDemo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ParallaxDemo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ParallaxDemo__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    Demo: __WEBPACK_IMPORTED_MODULE_0__components_ParallaxDemo___default.a
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__content__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  components: {
    'my-content': __WEBPACK_IMPORTED_MODULE_0__content___default.a
  },
  data: function data() {
    return {
      title: 'vue-parallax-js'
    };
  },

  computed: {
    ballPos: function ballPos() {
      var rnd = function rnd(max) {
        return Math.round(Math.random() * max);
      };
      var r = [];
      var circs = window.innerWidth / 20;
      if (circs < 30) circs = 30;

      for (var i = 0; i < circs; i++) {
        var par = Math.random() * 2;
        var size = (0 + 2 * par).toFixed(2);
        var left = rnd(80) + 10;
        var top = rnd(40) + 30;


        if (Math.random() < 0.5) {
          par = par * -1;
        }

        r.push({
          style: {
            left: left + '%',
            top: top + '%',
            width: size + 'vw',
            height: size + 'vw'
          },
          parallax: par.toFixed(2)
        });
      }
      return r;
    }
  }
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	name: 'content',
	computed: {
		basicUsageExample: function basicUsageExample() {
			return ['<h1 v-parallax="', '">vue-parallax-js</h1>'];
		},
		optioExample: function optioExample() {
			return ['<h1 v-parallax', '="0.2">vue-parallax-js</h1>'];
		}
	}
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(13),
  /* scopeId */
  "data-v-25268710",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax.absY",
      value: (-0.9),
      expression: "-0.9",
      modifiers: {
        "absY": true
      }
    }],
    staticClass: "h1title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax.absY",
      value: (1.2),
      expression: "1.2",
      modifiers: {
        "absY": true
      }
    }],
    staticClass: "h1title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.ballPos), function(ball) {
    return _c('i', {
      directives: [{
        name: "parallax",
        rawName: "v-parallax.centerX",
        value: (ball.parallax),
        expression: "ball.parallax",
        modifiers: {
          "centerX": true
        }
      }],
      style: (ball.style)
    })
  })], 2), _vm._v(" "), _c('my-content')], 1)
},staticRenderFns: []}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("vue-parallax-js")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b', [_vm._v("install via npm")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("in your main javascript file")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('pre', [_vm._v("\n" + _vm._s(_vm.basicUsageExample[0])), _c('span', [_vm._v("0.2")]), _vm._v(_vm._s(_vm.basicUsageExample[1]) + "\n\n"), _vm._m(7), _vm._v("\n"), _vm._m(8), _vm._v("\n"), _vm._m(9), _vm._v("\n\t\t\t")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("when adding vue-parallax-js to Vue you can pass some options")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('pre', [_vm._v("\n" + _vm._s(_vm.optioExample[0]) + "."), _c('span', [_vm._v("modifier")]), _vm._v(_vm._s(_vm.optioExample[1]) + "\n"), _vm._m(16), _vm._v("\n\t\t\t")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tvue component for parallax effect on elements "), _c('br'), _vm._v("\n\t\t\t\tno dependencies "), _c('br'), _vm._v("\n\t\t\t\tlightweight "), _c('br'), _vm._v("\n\t\t\t\t1.6 KB - minified"), _c('br'), _vm._v("\n\t\t\t\tfor "), _c('span', [_vm._v("Vue.js 2")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Setup "), _c('a', {
    attrs: {
      "href": "#setup",
      "name": "setup"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\nnpm install --save vue-parallax-js\n"), _c('em', [_vm._v("# or use yarn")]), _vm._v("\n"), _c('em', [_vm._v("# yarn add vue-parallax-js")]), _vm._v("\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("using "), _c('span', [_vm._v("vue-parallax-js")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\n"), _c('em', [_vm._v("// import Vue and vue-parallax-js")]), _vm._v("\nimport Vue from 'vue'\nimport VueParallaxJs from 'vue-parallax-js'\n\n"), _c('em', [_vm._v("// add vue-parallax-js to vue")]), _vm._v("\nVue.use(VueParallaxJs)\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Usage "), _c('a', {
    attrs: {
      "href": "#usage",
      "name": "usage"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("in your templates you can now use the "), _c('span', [_vm._v("v-parallax")]), _vm._v(" directive.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("0")]), _vm._v(" will appear static on the page (no effect)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("1")]), _vm._v(" will move along the page at the same speed as the scrolling")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("-1")]), _vm._v(" will move upwards at the same speed as the scrolling")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Options "), _c('a', {
    attrs: {
      "href": "#options",
      "name": "options"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\nVue.use(VueParallaxJs, "), _c('span', [_vm._v("{option: value}")]), _vm._v(")\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option head"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("option")]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_vm._v("value-type")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("minWidth")]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_vm._v("integer")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("minumum window width for parallax to take effect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Modifiers "), _c('a', {
    attrs: {
      "href": "#modifiers",
      "name": "modifiers"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("when using the "), _c('span', [_vm._v("v-parallax")]), _vm._v(" directive you can also pass some modifiers to configure the instance of vue-parallax-js")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_vm._v("// notice the "), _c('span', [_vm._v(".")]), _vm._v(" between \"v-parallax\" and the modifier")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option head"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("modifier")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("centerX")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("will add \"transform: "), _c('em', [_vm._v("translateX(-50%)")]), _vm._v("\" along with the parallax positioning")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("absY")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("uses the window height instead of the element height for the calculations")])])
}]}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo')
},staticRenderFns: []}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_parallax_js_src_vue_parallax_js__ = __webpack_require__(1);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__vue_parallax_js_src_vue_parallax_js__["a" /* default */], {});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[17]);


// WEBPACK FOOTER //
// static/js/app.c37f4a906e6ca0265b0b.js